import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  uploadInvoiceSettingsCertificate,
  getInvoiceSettingsCertificates,
  deleteCertificate,
  getInvoiceSettingsCertificateId,
} from './Certificate.service';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { useServiceError } from '@/hooks';
import { CertificateErrors } from './Certificate.erros';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

const dicionaryErrors: Record<string, string> = {
  'The password used': 'A senha do certificado informada está incorreta.',
  'already exists': 'Certificado já está em uso',
  'The certificate entered is expired.': 'O certificado inserido expirou.',
};

export function useInvoiceSettingsUploadCertificate() {
  const queryClient = useQueryClient();

  return useMutation(uploadInvoiceSettingsCertificate, {
    async onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Pfx foi importado com sucesso!',
      });
      await queryClient.invalidateQueries(['settings/certificates']);
    },
    onError(error) {
      notificationError(error, {
        translate: (errors) =>
          errors.map(
            (err) =>
              dicionaryErrors[
                Object.keys(dicionaryErrors).find((key) =>
                  err.includes(key),
                ) as string
              ] || err,
          ),
      });
    },
  });
}

export function useInvoiceSettingCertificates() {
  const mutation = useQuery(['settings/certificates'], () =>
    getInvoiceSettingsCertificates(),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useInvoiceSettingCertificate() {
  return useMutation(getInvoiceSettingsCertificateId);
}

export function useDeleteCertificate() {
  const queryChanel = useQueryChanel();

  const mutation = useMutation((id: number) => deleteCertificate(id), {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Certificado excluido com sucesso',
      });
      queryChanel({ invalidateQueries: [['settings/certificates']] });
    },

    onError(error) {
      notificationError(error, {
        translate: (errors) =>
          errors.map((err) => CertificateErrors[err] || err),
      });
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
